// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602271351/js/" + chunkId + "." + {"44":"e5618ced","225":"55c0a21e","481":"7f44da20","486":"802b323b","770":"fca46f80"}[chunkId] + ".0.571227433178235.chunk.js";
};